<template>
  <div>
    
    
  </div>
</template>

<script >
  
export default {
  data() {
    
  },
  
  watch: {
    
  },

  methods: {


  },

  created() {


  },

};

</script>

<style scoped>
  

</style>


// WEBPACK FOOTER //
// src/components/$MyVue.bak.vue